<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g opacity="0.3">
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" fill="#E6EBF0"/>
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" fill="#C1D1E5"/>
            <rect x="0.2" y="0.2" width="23.6" height="23.6" rx="2.8" stroke="#CEDCED" stroke-width="0.4"/>
        </g>
        <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="1.8" fill="white" stroke="#CEDCED" stroke-width="0.4"/>
    </svg>
</template>
<script>
const borderCheckInput = {
    name: 'borderCheckInput',
}
export default borderCheckInput
export { borderCheckInput }
</script>
